export default function ExecutorSection() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        {/* タイトル */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
            <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">About Us</p>
            <span className="w-12 h-px bg-[#8B6BAE]"></span>
          </div>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-4 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            実行者<span className="text-[#8B6BAE]">紹介</span>
          </h2>
          <p className="text-base text-[#6B6B6B] font-light">
            描く人のために、人間工学の視点から生まれたプロダクト
          </p>
        </div>

        {/* コンテンツ */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* 左側：ブランド情報 */}
          <div className="lg:col-span-2 space-y-4">
            {/* ブランドカード */}
            <div className="bg-[#F8F6FA] rounded-xl p-6 border border-[#E8E8E8]">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#8B6BAE] mb-4">
                <i className="ri-palette-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-medium text-[#2C2C2C] mb-2">
                MeVER（ミーバー）
              </h3>
              <p className="text-sm text-[#4A4A4A] leading-relaxed">
                「はたらく &amp; あそぶ」をコンセプトに、仕事と創作を支えるプロダクトを開発するブランドです。
              </p>
            </div>

            {/* コンタクト */}
            <div className="bg-[#F8F6FA] rounded-xl p-5 border border-[#E8E8E8]">
              <h4 className="text-sm text-[#8B6BAE] font-medium mb-3 uppercase tracking-wider">Contact</h4>
              <div className="space-y-2.5">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white border border-[#E8E8E8]">
                    <i className="ri-mail-line text-sm text-[#8B6BAE]"></i>
                  </div>
                  <span className="text-sm text-[#4A4A4A]">info@mever.design</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-white border border-[#E8E8E8]">
                    <i className="ri-global-line text-sm text-[#8B6BAE]"></i>
                  </div>
                  <span className="text-sm text-[#4A4A4A]">mever.design</span>
                </div>
              </div>
            </div>
          </div>

          {/* 右側：実行者紹介 */}
          <div className="lg:col-span-3">
            <div className="bg-[#F8F6FA] rounded-xl p-8 border border-[#E8E8E8] h-full">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white border-2 border-[#8B6BAE]">
                  <i className="ri-user-line text-xl text-[#8B6BAE]"></i>
                </div>
                <div>
                  <p className="text-xs text-[#8B6BAE] font-medium uppercase tracking-wider mb-0.5">Project Executor</p>
                  <h3 className="text-lg font-medium text-[#2C2C2C]">田村 善幸</h3>
                  <p className="text-sm text-[#6B6B6B]">ビットムーブスジャパン株式会社 代表</p>
                </div>
              </div>

              <div className="space-y-3 mb-6">
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  自身も楽器演奏やクリエイティブ活動を行う中で、<strong className="text-[#2C2C2C]">「姿勢と角度が、集中力を左右する」</strong>ことを実感。
                </p>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  ワークチェア開発で培った人間工学の視点を、次は"描く姿勢"に応用したいという想いからAtelier Folioは生まれました。
                </p>
              </div>

              {/* メッセージ */}
              <div className="bg-white rounded-lg p-5 border border-[#E8E8E8]">
                <div className="flex items-start gap-2">
                  <i className="ri-double-quotes-l text-2xl text-[#8B6BAE]/30"></i>
                  <p
                    className="text-base text-[#2C2C2C] font-light leading-relaxed"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    描く人が、どこでも描ける環境を。
                    <br />
                    それがこのプロジェクトの原点です。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
